import * as React from 'react';
import styled from 'styled-components';

interface ButtonProps {
  isActive: boolean;
}

export const MenuList = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  overflow: hidden;
  list-style-type: none;
`;

const MenuItem = styled.li<ButtonProps>`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 0.4em;
  background: #fefefe;
  cursor: pointer;
  border-radius: ${props => props.isActive  ? '8px' : 'none'};
  background: ${props => props.isActive  ? '#4ecdc4' : 'white'};
  color: ${props => props.isActive  ? 'white' : 'black'};
  @media (max-width: 500px) {
    font-size: 18px;
  }
  @media (max-width: 400px) {
    font-size: 16px;
  }
`;

interface IProps {
  appMode: string;
  showRewardCategoryList: () => void;
  showPurchaseHistory: () => void;
}

export default function Menu(props: IProps) {
  return (
    <MenuList>
      <MenuItem
        isActive={props.appMode === 'RewardCategoryList'}
        onClick={props.showRewardCategoryList}
      >Shop</MenuItem>
    </MenuList>
  );
}



// WEBPACK FOOTER //
// ./src/components/Menu.tsx